import { render, staticRenderFns } from "./QuickPay.vue?vue&type=template&id=228e6cf0"
import script from "./QuickPay.vue?vue&type=script&lang=js"
export * from "./QuickPay.vue?vue&type=script&lang=js"
import style0 from "./QuickPay.vue?vue&type=style&index=0&id=228e6cf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports